import React, { useRef } from 'react';
import t from '~t';
import { useSelector, useDispatch } from 'react-redux';
import { upload, cancel } from '~data/actions/import';
import config from '~config';

import { Error } from '~co/overlay/dialog';
import { Label, Button, Alert, Icon, Preloader } from '~ui';

export default function ImportFile() {
  const file = useSelector((state) => state.import.file);
  const dispatch = useDispatch();
  const input = useRef(null);

  const onFileUpload = (e) => {
    if (!e.target.files[0]) return;

    dispatch(
      upload(e.target.files[0], undefined, (e) => {
        Error(e);
        input.current.value = '';
      }),
    );
  };

  const renderButton = () => {
    const { status, name, count } = file;

    switch (status) {
      case 'loading':
        return (
          <Button variant='ghost'>
            <Preloader />
            {t.s('uploadProgress')}
          </Button>
        );

      case 'loaded':
        return (
          <div className='py-[var(--padding-mini)]'>
            <b className='text-[length:var(--title-font-size)]'>{name}</b>
            <br />
            <span className='text-muted-foreground'>
              {count.folders} {t.s('folders').toLowerCase()},{' '}
              {count.bookmarks} {t.s('bookmarks')}, {count.tags}{' '}
              {t.s('tags').toLowerCase()}, {count.highlights}{' '}
              {t.s('highlights').toLowerCase()}
            </span>

            {count.duplicates ? (
              <>
                <br />
                <br />

                <Alert variant='warning'>
                  Your file contains <b>{count.duplicates} duplicate
                  bookmarks</b>. Only{' '}
                  <b>
                    {count.bookmarks - count.duplicates} unique bookmarks
                    will be imported
                  </b>
                  .
                </Alert>
              </>
            ) : null}
          </div>
        );

      case 'empty':
        return (
          <div>
            <Alert variant='warning'>
              <b>{t.s('noBookmarks')}</b>
            </Alert>
            <br />

            <Button variant='outline' onClick={() => dispatch(cancel())}>
              <Icon name='refresh' />
              {t.s('selectOtherFile')}
            </Button>
          </div>
        );

      default:
        return (
          <div>
            <Alert>
              <b>
                {t.s('uploadBookmarksFile')}{' '}
                {t.s('uploadBookmarksFileFormats')}
              </b>
              .<br />
              {t.s('importInfo2')}
              <br />
              <br />
              <a
                href={config.links.help.import + '#supported-formats'}
                target='_blank'
              >
                {t.s('help')}
                <Icon name='open' size='micro' style={{ marginLeft: 6 }} />
              </a>
            </Alert>
            <br />

            <Button onClick={() => input.current?.click()}>
              <Icon name='upload' />
              {t.s('uploadFile')}
            </Button>

            <input
              ref={input}
              type='file'
              accept='*/*'
              className='hidden'
              onChange={onFileUpload}
            />
          </div>
        );
    }
  };

  return (
    <>
      <Label>{t.s('file')}</Label>

      {renderButton()}
    </>
  );
}
